module.exports = __webpack_public_path__ + "fonts/GT-Pressura-Mono-Bold.3bcccda.woff2";